import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga la Guía',
    desc: 'Recibe acceso inmediato a tu PDF tras la compra.'
  }, {
    num: '2',
    title: 'Consulta las Tablas',
    desc: 'Busca los suplementos que ya tienes y ajusta tus horarios.'
  }, {
    num: '3',
    title: 'Optimiza tu Compra',
    desc: 'Usa el Bono #2 para que tu próxima adquisición sea de calidad garantizada.'
  }];
  return <Section bg="cream-dark" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-93">
          Cómo funciona
        </h2>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-94">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-1/6 right-1/6 h-0.5 bg-sage-200 -z-10" data-id="element-95"></div>

          {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-96">
              <div className="w-16 h-16 rounded-full bg-sage-700 text-white flex items-center justify-center text-2xl font-bold mb-6 shadow-lg border-4 border-cream-dark" data-id="element-97">
                {step.num}
              </div>
              <h3 className="text-xl font-bold mb-3 text-sage-900" data-id="element-98">
                {step.title}
              </h3>
              <p className="text-charcoal-light" data-id="element-99">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}